export default __webpack_public_path__ + "static/media/teach-2.e0c1fb50.jpg";